import React from "react"
import { Modal, Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import styles from "./index.module.css"
import SingleTicketIcon from "assets/icons/new/single-ticket.svg"
import MultiTicketsIcon from "assets/icons/new/multi-tickets.svg"

export const AddNewListing = ({ selectedType, setSelectedType, isOpen, onClose, onContinue }) => {
  const { t } = useTranslation()

  const listingTypes = [
    {
      key: "private",
      title: t("experiences.private_listing"),
      description: t("experiences.private_listing_description"),
      icon: <img src={SingleTicketIcon} alt="Private Listing" />
    },
    // {
    //   key: "ticketed",
    //   title: t("experiences.ticketed_listing"),
    //   description: t("experiences.ticketed_listing_description"),
    //   icon: <img src={MultiTicketsIcon} alt="Ticketed Listing" />
    // },
    // {
    //   key: "rental",
    //   title: t("experiences.rental_listing"),
    //   description: t("experiences.rental_listing_description"),
    //   icon: <img src={RentalListingIcon} alt="Rental Listing" />
    // }
  ]

  const handleContinue = () => {
    if (selectedType) {
      onContinue?.(selectedType)
    }
  }

  return (
    <Modal maskClosable={false} open={isOpen} onCancel={onClose} footer={null} width={640} className={styles.modal} centered>
      <div>
        <h2 className={styles.title}>{t("experiences.select_experience_type")}</h2>
        <div className={styles.listingOptions}>
          {listingTypes.map((type) => (
            <button
              key={type.key}
              className={`${styles.listingCard} ${selectedType === type.key ? styles.selected : ""}`}
              onClick={() => setSelectedType(type.key)}
              type="button"
            >
              <div className={styles.cardContent}>
                <div>{type.icon}</div>
                <h3 className={styles.cardTitle}>{type.title}</h3>
                <p className={styles.description}>{type.description}</p>
              </div>
            </button>
          ))}
        </div>

        {/* Footer Actions */}
        <Flex align="center" gap={6} className="mt-l">
          <Button color="primary" variant="outlined" onClick={onClose}>
            {t("global.cancel")}
          </Button>
          <Button color="primary" variant="solid" onClick={handleContinue} disabled={!selectedType}>
            {t("experiences.continue")}
          </Button>
        </Flex>
      </div>
    </Modal>
  )
}

AddNewListing.propTypes = {
  selectedType: PropTypes.string,
  setSelectedType: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onContinue: PropTypes.func
}

AddNewListing.defaultProps = {
  onContinue: () => {}
}
